/* eslint-disable */
/* tslint:disable */
/*
 * DO NOT EDIT THIS FILE!
 * YOUR CHANGES WILL BE OVERWRITTEN!
 * FILE IS BASED ON .wuf/testkits/testing-library.template.ejs
 * AND GENERATED BY `wuf export-testkits`
 */
import { uniTestkitFactoryCreator } from '@wix/wix-ui-test-utils/testing-library';
import { jsdomReactUniDriver as jsdomReactTestingLibraryReactUniDriver} from '@wix/unidriver-jsdom-react';
import { setUniDriverImplementation } from "../test/unidriver-config"

setUniDriverImplementation(jsdomReactTestingLibraryReactUniDriver)


import { accordionDriverFactory } from '../components/Accordion/Accordion.driver';
// @ts-ignore
export const accordionTestkitFactory = uniTestkitFactoryCreator(accordionDriverFactory);

import { actionsMenuLayoutDriverFactory } from '../components/ActionsMenuLayout/ActionsMenuLayout.driver';
// @ts-ignore
export const actionsMenuLayoutTestkitFactory = uniTestkitFactoryCreator(actionsMenuLayoutDriverFactory);

import { addItemDriverFactory } from '../components/AddItem/AddItem.driver';
// @ts-ignore
export const addItemTestkitFactory = uniTestkitFactoryCreator(addItemDriverFactory);

import { autocompleteDriverFactory } from '../components/Autocomplete/Autocomplete.driver';
// @ts-ignore
export const autocompleteTestkitFactory = uniTestkitFactoryCreator(autocompleteDriverFactory);

import { avatarDriverFactory } from '../components/Avatar/Avatar.driver';
// @ts-ignore
export const avatarTestkitFactory = uniTestkitFactoryCreator(avatarDriverFactory);

import { avatarGroupDriverFactory } from '../components/AvatarGroup/AvatarGroup.driver';
// @ts-ignore
export const avatarGroupTestkitFactory = uniTestkitFactoryCreator(avatarGroupDriverFactory);

import { badgeDriverFactory } from '../components/Badge/Badge.driver';
// @ts-ignore
export const badgeTestkitFactory = uniTestkitFactoryCreator(badgeDriverFactory);

import { boxSelectionDriverFactory } from '../components/BoxSelection/BoxSelection.driver';
// @ts-ignore
export const boxSelectionTestkitFactory = uniTestkitFactoryCreator(boxSelectionDriverFactory);

import { breadcrumbsDriverFactory } from '../components/Breadcrumbs/Breadcrumbs.driver';
// @ts-ignore
export const breadcrumbsTestkitFactory = uniTestkitFactoryCreator(breadcrumbsDriverFactory);

import { buttonDriverFactory } from '../components/Button/Button.driver';
// @ts-ignore
export const buttonTestkitFactory = uniTestkitFactoryCreator(buttonDriverFactory);

import { calendarCellDriverFactory } from '../components/CalendarCell/CalendarCell.driver';
// @ts-ignore
export const calendarCellTestkitFactory = uniTestkitFactoryCreator(calendarCellDriverFactory);

import { calendarPopoverDriverFactory } from '../components/CalendarPopover/CalendarPopover.driver';
// @ts-ignore
export const calendarPopoverTestkitFactory = uniTestkitFactoryCreator(calendarPopoverDriverFactory);

import { cardDriverFactory } from '../components/Card/Card.driver';
// @ts-ignore
export const cardTestkitFactory = uniTestkitFactoryCreator(cardDriverFactory);

import { checkboxDriverFactory } from '../components/Checkbox/Checkbox.driver';
// @ts-ignore
export const checkboxTestkitFactory = uniTestkitFactoryCreator(checkboxDriverFactory);

import { checkboxGroupDriverFactory } from '../components/CheckboxGroup/CheckboxGroup.driver';
// @ts-ignore
export const checkboxGroupTestkitFactory = uniTestkitFactoryCreator(checkboxGroupDriverFactory);

import { colorPickerDriverFactory } from '../components/ColorPicker/ColorPicker.driver';
// @ts-ignore
export const colorPickerTestkitFactory = uniTestkitFactoryCreator(colorPickerDriverFactory);

import { copyUrlButtonDriverFactory } from '../components/CopyUrlButton/CopyUrlButton.driver';
// @ts-ignore
export const copyUrlButtonTestkitFactory = uniTestkitFactoryCreator(copyUrlButtonDriverFactory);

import { counterDriverFactory } from '../components/Counter/Counter.driver';
// @ts-ignore
export const counterTestkitFactory = uniTestkitFactoryCreator(counterDriverFactory);

import { counterBadgeDriverFactory } from '../components/CounterBadge/CounterBadge.driver';
// @ts-ignore
export const counterBadgeTestkitFactory = uniTestkitFactoryCreator(counterBadgeDriverFactory);

import { customDialogDriverFactory } from '../components/CustomDialog/CustomDialog.driver';
// @ts-ignore
export const customDialogTestkitFactory = uniTestkitFactoryCreator(customDialogDriverFactory);

import { datePickerInputDriverFactory } from '../components/DatePickerInput/DatePickerInput.driver';
// @ts-ignore
export const datePickerInputTestkitFactory = uniTestkitFactoryCreator(datePickerInputDriverFactory);

import { datePickerInputOldDriverFactory } from '../components/DatePickerInputOld/DatePickerInputOld.driver';
// @ts-ignore
export const datePickerInputOldTestkitFactory = uniTestkitFactoryCreator(datePickerInputOldDriverFactory);

import { dialogDriverFactory } from '../components/Dialog/Dialog.driver';
// @ts-ignore
export const dialogTestkitFactory = uniTestkitFactoryCreator(dialogDriverFactory);

import { dotNavigationDriverFactory } from '../components/DotNavigation/DotNavigation.driver';
// @ts-ignore
export const dotNavigationTestkitFactory = uniTestkitFactoryCreator(dotNavigationDriverFactory);

import { dropdownDriverFactory } from '../components/Dropdown/Dropdown.driver';
// @ts-ignore
export const dropdownTestkitFactory = uniTestkitFactoryCreator(dropdownDriverFactory);

import { eventDriverFactory } from '../components/Event/Event.driver';
// @ts-ignore
export const eventTestkitFactory = uniTestkitFactoryCreator(eventDriverFactory);

import { fileUploadDriverFactory } from '../components/FileUpload/FileUpload.driver';
// @ts-ignore
export const fileUploadTestkitFactory = uniTestkitFactoryCreator(fileUploadDriverFactory);

import { floatingDropdownDriverFactory } from '../components/FloatingDropdown/FloatingDropdown.driver';
// @ts-ignore
export const floatingDropdownTestkitFactory = uniTestkitFactoryCreator(floatingDropdownDriverFactory);

import { gridDriverFactory } from '../components/Grid/Grid.driver';
// @ts-ignore
export const gridTestkitFactory = uniTestkitFactoryCreator(gridDriverFactory);

import { heroImageDriverFactory } from '../components/HeroImage/HeroImage.driver';
// @ts-ignore
export const heroImageTestkitFactory = uniTestkitFactoryCreator(heroImageDriverFactory);

import { iconButtonDriverFactory } from '../components/IconButton/IconButton.driver';
// @ts-ignore
export const iconButtonTestkitFactory = uniTestkitFactoryCreator(iconButtonDriverFactory);

import { iconToggleDriverFactory } from '../components/IconToggle/IconToggle.driver';
// @ts-ignore
export const iconToggleTestkitFactory = uniTestkitFactoryCreator(iconToggleDriverFactory);

import { iconTooltipDriverFactory } from '../components/IconTooltip/IconTooltip.driver';
// @ts-ignore
export const iconTooltipTestkitFactory = uniTestkitFactoryCreator(iconTooltipDriverFactory);

import { imageDriverFactory } from '../components/Image/Image.driver';
// @ts-ignore
export const imageTestkitFactory = uniTestkitFactoryCreator(imageDriverFactory);

import { inputDriverFactory } from '../components/Input/Input.driver';
// @ts-ignore
export const inputTestkitFactory = uniTestkitFactoryCreator(inputDriverFactory);

import { inputDialogDriverFactory } from '../components/InputDialog/InputDialog.driver';
// @ts-ignore
export const inputDialogTestkitFactory = uniTestkitFactoryCreator(inputDialogDriverFactory);

import { legacyCardDriverFactory } from '../components/LegacyCard/LegacyCard.driver';
// @ts-ignore
export const legacyCardTestkitFactory = uniTestkitFactoryCreator(legacyCardDriverFactory);

import { likeButtonDriverFactory } from '../components/LikeButton/LikeButton.driver';
// @ts-ignore
export const likeButtonTestkitFactory = uniTestkitFactoryCreator(likeButtonDriverFactory);

import { mediaLabelDriverFactory } from '../components/MediaLabel/MediaLabel.driver';
// @ts-ignore
export const mediaLabelTestkitFactory = uniTestkitFactoryCreator(mediaLabelDriverFactory);

import { mobileDrawerDriverFactory } from '../components/MobileDrawer/MobileDrawer.driver';
// @ts-ignore
export const mobileDrawerTestkitFactory = uniTestkitFactoryCreator(mobileDrawerDriverFactory);

import { overlappingCardDriverFactory } from '../components/OverlappingCard/OverlappingCard.driver';
// @ts-ignore
export const overlappingCardTestkitFactory = uniTestkitFactoryCreator(overlappingCardDriverFactory);

import { paginationDriverFactory } from '../components/Pagination/Pagination.driver';
// @ts-ignore
export const paginationTestkitFactory = uniTestkitFactoryCreator(paginationDriverFactory);

import { pickerDriverFactory } from '../components/Picker/Picker.driver';
// @ts-ignore
export const pickerTestkitFactory = uniTestkitFactoryCreator(pickerDriverFactory);

import { popoverDriverFactory } from '../components/Popover/Popover.driver';
// @ts-ignore
export const popoverTestkitFactory = uniTestkitFactoryCreator(popoverDriverFactory);

import { progressBarDriverFactory } from '../components/ProgressBar/ProgressBar.driver';
// @ts-ignore
export const progressBarTestkitFactory = uniTestkitFactoryCreator(progressBarDriverFactory);

import { radioButtonDriverFactory } from '../components/RadioButton/RadioButton.driver';
// @ts-ignore
export const radioButtonTestkitFactory = uniTestkitFactoryCreator(radioButtonDriverFactory);

import { radioButtonGroupDriverFactory } from '../components/RadioButtonGroup/RadioButtonGroup.driver';
// @ts-ignore
export const radioButtonGroupTestkitFactory = uniTestkitFactoryCreator(radioButtonGroupDriverFactory);

import { rangeDriverFactory } from '../components/Range/Range.driver';
// @ts-ignore
export const rangeTestkitFactory = uniTestkitFactoryCreator(rangeDriverFactory);

import { ratingsDriverFactory } from '../components/Ratings/Ratings.driver';
// @ts-ignore
export const ratingsTestkitFactory = uniTestkitFactoryCreator(ratingsDriverFactory);

import { ratingsInputDriverFactory } from '../components/RatingsInput/RatingsInput.driver';
// @ts-ignore
export const ratingsInputTestkitFactory = uniTestkitFactoryCreator(ratingsInputDriverFactory);

import { reactionsDriverFactory } from '../components/Reactions/Reactions.driver';
// @ts-ignore
export const reactionsTestkitFactory = uniTestkitFactoryCreator(reactionsDriverFactory);

import { reviewSummaryDriverFactory } from '../components/ReviewSummary/ReviewSummary.driver';
// @ts-ignore
export const reviewSummaryTestkitFactory = uniTestkitFactoryCreator(reviewSummaryDriverFactory);

import { ribbonDriverFactory } from '../components/Ribbon/Ribbon.driver';
// @ts-ignore
export const ribbonTestkitFactory = uniTestkitFactoryCreator(ribbonDriverFactory);

import { sectionNotificationDriverFactory } from '../components/SectionNotification/SectionNotification.driver';
// @ts-ignore
export const sectionNotificationTestkitFactory = uniTestkitFactoryCreator(sectionNotificationDriverFactory);

import { shareButtonDriverFactory } from '../components/ShareButton/ShareButton.driver';
// @ts-ignore
export const shareButtonTestkitFactory = uniTestkitFactoryCreator(shareButtonDriverFactory);

import { skeletonLineDriverFactory } from '../components/SkeletonLine/SkeletonLine.driver';
// @ts-ignore
export const skeletonLineTestkitFactory = uniTestkitFactoryCreator(skeletonLineDriverFactory);

import { socialBarDriverFactory } from '../components/SocialBar/SocialBar.driver';
// @ts-ignore
export const socialBarTestkitFactory = uniTestkitFactoryCreator(socialBarDriverFactory);

import { spinnerDriverFactory } from '../components/Spinner/Spinner.driver';
// @ts-ignore
export const spinnerTestkitFactory = uniTestkitFactoryCreator(spinnerDriverFactory);

import { statesButtonDriverFactory } from '../components/StatesButton/StatesButton.driver';
// @ts-ignore
export const statesButtonTestkitFactory = uniTestkitFactoryCreator(statesButtonDriverFactory);

import { stripCardDriverFactory } from '../components/StripCard/StripCard.driver';
// @ts-ignore
export const stripCardTestkitFactory = uniTestkitFactoryCreator(stripCardDriverFactory);

import { tabbedContentDriverFactory } from '../components/TabbedContent/TabbedContent.driver';
// @ts-ignore
export const tabbedContentTestkitFactory = uniTestkitFactoryCreator(tabbedContentDriverFactory);

import { tabsDriverFactory } from '../components/Tabs/Tabs.driver';
// @ts-ignore
export const tabsTestkitFactory = uniTestkitFactoryCreator(tabsDriverFactory);

import { tagDriverFactory } from '../components/Tag/Tag.driver';
// @ts-ignore
export const tagTestkitFactory = uniTestkitFactoryCreator(tagDriverFactory);

import { tagsDriverFactory } from '../components/Tags/Tags.driver';
// @ts-ignore
export const tagsTestkitFactory = uniTestkitFactoryCreator(tagsDriverFactory);

import { textDriverFactory } from '../components/Text/Text.driver';
// @ts-ignore
export const textTestkitFactory = uniTestkitFactoryCreator(textDriverFactory);

import { textAreaDriverFactory } from '../components/TextArea/TextArea.driver';
// @ts-ignore
export const textAreaTestkitFactory = uniTestkitFactoryCreator(textAreaDriverFactory);

import { textButtonDriverFactory } from '../components/TextButton/TextButton.driver';
// @ts-ignore
export const textButtonTestkitFactory = uniTestkitFactoryCreator(textButtonDriverFactory);

import { textFieldDriverFactory } from '../components/TextField/TextField.driver';
// @ts-ignore
export const textFieldTestkitFactory = uniTestkitFactoryCreator(textFieldDriverFactory);

import { threeDotsLoaderDriverFactory } from '../components/ThreeDotsLoader/ThreeDotsLoader.driver';
// @ts-ignore
export const threeDotsLoaderTestkitFactory = uniTestkitFactoryCreator(threeDotsLoaderDriverFactory);

import { thumbnailImageDriverFactory } from '../components/ThumbnailImage/ThumbnailImage.driver';
// @ts-ignore
export const thumbnailImageTestkitFactory = uniTestkitFactoryCreator(thumbnailImageDriverFactory);

import { toastDriverFactory } from '../components/Toast/Toast.driver';
// @ts-ignore
export const toastTestkitFactory = uniTestkitFactoryCreator(toastDriverFactory);

import { toggleSwitchDriverFactory } from '../components/ToggleSwitch/ToggleSwitch.driver';
// @ts-ignore
export const toggleSwitchTestkitFactory = uniTestkitFactoryCreator(toggleSwitchDriverFactory);

import { tooltipDriverFactory } from '../components/Tooltip/Tooltip.driver';
// @ts-ignore
export const tooltipTestkitFactory = uniTestkitFactoryCreator(tooltipDriverFactory);

import { weeklyDateNavigationDriverFactory } from '../components/WeeklyDateNavigation/WeeklyDateNavigation.driver';
// @ts-ignore
export const weeklyDateNavigationTestkitFactory = uniTestkitFactoryCreator(weeklyDateNavigationDriverFactory);

import { weeklyDatePickerDriverFactory } from '../components/WeeklyDatePicker/WeeklyDatePicker.driver';
// @ts-ignore
export const weeklyDatePickerTestkitFactory = uniTestkitFactoryCreator(weeklyDatePickerDriverFactory);

import { wowImageDriverFactory } from '../components/WowImage/WowImage.driver';
// @ts-ignore
export const wowImageTestkitFactory = uniTestkitFactoryCreator(wowImageDriverFactory);

